let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("bf0yj")).then(() => parcelRequire('3yfJl'));